import { LOGIN } from "../configs/routes";
import api from "./api";

export const login = (user) =>
    new Promise((resolve, reject) => {
        const isLoggingIn = true;
        api
            .post(LOGIN, user, isLoggingIn)
            .then((response) => resolve(response.data))
            .catch((err) =>{ reject(err.response?.data?.errors?.non_field_errors[0] || "Something went wrong" )});

    });
